import * as authSagas from './auth.js'
import * as userSagas from './users.js'
import * as errorSagas from './errors.js'
import * as forgotPasswordSagas from './forgotPassword.js'
import * as unsubscribeSagas from './unsubscribe'
import * as newPasswordSagas from './newPassword.js'
import * as changePasswordSagas from './changePassword.js'
import * as webinarSagas from './webinars.js'
import * as subscriptionSagas from './subscriptions.js'
import * as vimeoSagas from './vimeo.js'
import * as quizSagas from './quiz.js'
import * as suggestionSagas from './suggestions.js'
import * as confirmEmailSagas from './confirmEmail.js'

import * as adminUsersSagas from './admin/users.js'
import * as adminWebinarsSagas from './admin/webinars.js'
import * as dashboardUsersSagas from './admin/dashboard.js'

import * as adminSponsorsSagas from './admin/sponsors.js'
import * as adminDisciplinesSagas from './admin/disciplines.js'
import * as adminPartnersSagas from './admin/partners.js'
import * as sponsorsSagas from './sponsors.js'
import * as disciplinesSagas from './diciplines.js'
import * as partnersSagas from './partners.js'
import * as adminLandingData from './admin/landing.js'
import * as userLandingData from './landing.js'
import * as statsSagas from './stats'
import * as calendarData from './calendar.js'

import * as superhostsSagas from './admin/superhosts'
import * as studygroupsSagas from './admin/studygroups'
import * as zoomSagas from './admin/zoom.js'

import * as clientUrlsSagas from './admin/clientUrls.js';
import * as clientWebinarsSagas from './clientUrls.js';

import { fork } from 'redux-saga/effects'

const sagas = {
  ...disciplinesSagas,
  ...adminDisciplinesSagas,
  ...authSagas,
  ...userSagas,
  ...errorSagas,
  ...forgotPasswordSagas,
  ...unsubscribeSagas,
  ...newPasswordSagas,
  ...changePasswordSagas,
  ...webinarSagas,
  ...subscriptionSagas,
  ...vimeoSagas,
  ...quizSagas,
  ...suggestionSagas,
  ...confirmEmailSagas,
  ...adminUsersSagas,
  ...dashboardUsersSagas,
  ...adminWebinarsSagas,
  ...adminSponsorsSagas,
  ...sponsorsSagas,
  ...partnersSagas,
  ...adminPartnersSagas,
  ...adminLandingData,
  ...userLandingData,
  ...statsSagas,
  ...calendarData,
  ...superhostsSagas,
  ...studygroupsSagas,
  ...zoomSagas,
  ...clientUrlsSagas,
  ...clientWebinarsSagas,
};

export default function* root() {
  yield [
    ...Object.keys(sagas).map(sagaKey => fork(sagas[sagaKey]))
  ];
};



// WEBPACK FOOTER //
// ./src/sagas/index.js